import { Fragment, useEffect } from "react";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../hooks/useTypedSelector";
import {
  fetchEvents,
  fetchEventsCount,
} from "../../infrastructure/eventMutateSlice";
import { useAuthorization } from "../../../../hooks/useAuthorization";

export const EventPollingProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { user } = useAppSelector((state) => state.auth);
  const { pollingActive } = useAppSelector((state) => state.eventMutate);

  const dispatch = useAppDispatch();

  const { hasRole } = useAuthorization();

  useEffect(() => {
    if (!user || Object.keys(user).length === 0) {
      return;
    }

    if (!pollingActive) {
      return;
    }

    // Set up polling interval
    const pollingInterval = setInterval(() => {
      void dispatch(fetchEvents(new Date(Date.now() - 10000)));
    }, 10000); // Poll every 10 seconds

    // Clean up interval on unmount
    return () => {
      clearInterval(pollingInterval);
    };
  }, [user, pollingActive]);

  useEffect(() => {
    if (!user || Object.keys(user).length === 0) {
      return;
    }

    if (!(hasRole("super-admin") || hasRole("dbh-manager"))) {
      return;
    }

    void dispatch(fetchEventsCount());
    const pollingInterval = setInterval(() => {
      void dispatch(fetchEventsCount());
    }, 60000);

    return () => {
      clearInterval(pollingInterval);
    };
  }, [user, pollingActive, hasRole]);

  return <Fragment>{children}</Fragment>;
};
